let ventaDataGlobal = null;

export function setVentaData(data) {
  // Generar campos concatenados si existe 'productos'
  if (data.productos && Array.isArray(data.productos)) {
    const productoIds = [];
    const cantidades = [];
    const precios = [];
    const nombres = [];

    data.productos.forEach((p) => {
      productoIds.push(p.id);
      cantidades.push(p.cantidad);
      precios.push(p.precio);
      nombres.push(p.nombre);
    });

    data.productoId = productoIds.join('-');
    data.cantidad = cantidades.join('-');
    data.precioNormalPorProducto = precios.join('-');
    data.nombre = nombres.join(' | ');
  }

  ventaDataGlobal = data;
  console.log('📦 Datos de venta almacenados temporalmente:', ventaDataGlobal);
}

export function getVentaData() {
  return ventaDataGlobal;
}


export function clearVentaData() {
  localStorage.removeItem('ventaData');
}

